export const LOGIN_CLIENT_ID = 'pdnoomneeuq'

export const REST_BASE_SERVER_URL_KEY = 'rest_base_url'

export const GRAPHQL_BASE_SERVER_URL_KEY = 'graphql_base_url'
export const GRAPHQL_SUBSCRIPTION_SERVER_URL_KEY = 'graphql_subscription_url'

export const SELECTED_ENV_KEY = 'selected_env'
